module.exports = __webpack_public_path__ + "img/Sleet.7948a3a7.png";